import { connect } from 'react-redux';
import { SecretField } from 'components/common';
import { Box, BoxEmpty } from 'components/common/box';
import { FormGroup } from 'components/common/form';

const PathIntegrations = connect(state => ({
  messages: state.messages,
  pageState: state.pageState,
  serverConfig: state.serverConfig
}))(({
  messages,
  pageState: { path },
  serverConfig
}) => (
  <div className="integrations">
    <Box title={messages.settingsIntegrations}>
      {serverConfig.showPathHash ? (
        <div>
          <FormGroup
            label={messages.pathsHash}
          >
            <SecretField
              value={path.hash}
            />
          </FormGroup>
        </div>
      ) : (
        <BoxEmpty
          padding={0}
          text={messages.settingsIntegrationsNone}
        />
      )}
    </Box>
  </div>
));

export default PathIntegrations;
